var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.65389 8.00002C3.57382 10.0047 5.54716 11.4 7.9999 11.4C10.4526 11.4 12.426 10.0047 13.3459 8.00002C12.426 5.9954 10.4526 4.60002 7.9999 4.60002C5.54716 4.60002 3.57382 5.9954 2.65389 8.00002ZM1.44476 7.77239C2.49321 5.21554 4.9477 3.40002 7.9999 3.40002C11.0521 3.40002 13.5066 5.21554 14.555 7.77239C14.6149 7.91825 14.6149 8.0818 14.555 8.22766C13.5066 10.7845 11.0521 12.6 7.9999 12.6C4.9477 12.6 2.49321 10.7845 1.44476 8.22766C1.38495 8.0818 1.38495 7.91825 1.44476 7.77239Z",
    fill: "#717B8E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.9999 8.00002C9.9999 9.10459 9.10447 10 7.9999 10C6.89533 10 5.9999 9.10459 5.9999 8.00002C5.9999 6.89545 6.89533 6.00002 7.9999 6.00002C9.10447 6.00002 9.9999 6.89545 9.9999 8.00002Z",
    fill: "#717B8E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.e264416fe8f7511c65ccaf3afd5ef601.svg";
export { ForwardRef as ReactComponent };